module.exports = __webpack_public_path__ + "static/caixa-logo-v2-41dbc9bb2dbf2bc8b582673ce3186756.svg";